// client/src/hooks/useTypingEmitter.js
import { useCallback } from 'react';
import { getSocket } from '../Utilities/socketClient';

export default function useTypingEmitter(userId, serverChats) {
    return useCallback(
        (chatId, isTyping) => {
            const socket = getSocket();
            if (!socket || !socket.connected || !userId || !chatId) return;

            const chat = serverChats.find((c) => String(c._id) === String(chatId));
            const type = chat?.type || 'DM';

            if (type === 'GROUP') {
                socket.emit(isTyping ? 'group-typing' : 'group-stop-typing', {
                    groupId: chatId,
                    userId,
                });
            } else {
                socket.emit(isTyping ? 'typing' : 'stopTyping', chatId);
            }
        },
        [userId, serverChats]
    );
}
